import React from "react";
import { useSelector } from "react-redux";
import { useTypedDispatch } from "../../../app/state";
import { selectAllFiles, selectCurrentFileId } from "../../../store/fileStore/fileSelectors";
import { selectAllCountries } from "../../../store/countryStore/countrySelectors";
import { selectAllLocations } from "../../../store/locationStore/locationSelectors";
import { extractFilesData } from "../filesHelper";
import { TableList } from "../../../app/components/TableList";
import { setCurrentFileId } from "../../../store/fileStore/fileState";
import HorizontalPanel from "../../../components/HorizontalPanel";
import { Toolbar } from "../../../app/components";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { IconButton } from "@material-ui/core";

import classes from './index.module.scss';

const FilesTable = () => {
  const dispatch = useTypedDispatch();
  const fileList = useSelector(selectAllFiles);
  const selectedFileId = useSelector(selectCurrentFileId);
  const allCountryList = useSelector(selectAllCountries) || [];
  const allLocationList = useSelector(selectAllLocations) || [];

  const selectFile = (id) => {
    dispatch(setCurrentFileId(id));
  }

  const onCreateNew = () => selectFile(-1);

  const columns = [
    { flex: 1, field: 'name', headerName: 'Name', maxLength: 50 },
    { flex: 1, field: 'size', headerName: 'Size', maxLength: 50 },
    { flex: 1, field: 'uploadDate', headerName: 'Upload Date', maxLength: 50 },
    { flex: 1, field: 'uploadedBy', headerName: 'Uploaded by', maxLength: 50 },
    { flex: 1, field: 'country', headerName: 'Country', maxLength: 50 },
    { flex: 1, field: 'locations', headerName: 'Locations', maxLength: 50 },
    { flex: 1, field: 'buildings', headerName: 'Buildings', maxLength: 50 },
  ];

  const filesViewModel = fileList.map((file) => extractFilesData(file, allCountryList, allLocationList));

  return (
    <HorizontalPanel size={HorizontalPanel.SIZES.SMALL} className={classes.container}>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <Toolbar title="File list">
          <IconButton
            aria-label='upload new file'
            color='secondary'
            size='small'
            onClick={onCreateNew}
          >
            <AddCircleOutlineIcon />
          </IconButton>
        </Toolbar>
      </HorizontalPanel>
      <HorizontalPanel size={HorizontalPanel.SIZES.REST_SPACE} addScroll>
        <TableList
          selectedId={selectedFileId}
          columns={columns}
          rows={filesViewModel}
          selectRow={selectFile}
        />
      </HorizontalPanel>
    </HorizontalPanel>
  )
}

export default FilesTable